export default {
  CREATE: `Create a hiring data`,
  DELETE_BUTTON: {
    TITLE: `Delete the hiring data`,
    SUMMARY: `Are you sure you want to delete this hiring data?`,
    PRIMARY_ACTION: `Delete the hiring data`
  },
  LIST: {
    TITLE: `Hiring data list`,
    SUMMARY: ``
  },
  TYPE: `Type`,
  DESCRIPTION: `Description`,
  HAS_VALID_PERIOD: `Has a valid period`,
  NB_HOURS_MIN: `Number of minimal hours`,
  NB_HOURS_MAX: `Number of maximal hours`,
  DISPONIBILITY_APPROVED_DEFAULT: `Availability approved automatically`,
  NOT_UPDATE_AVAILABILITY: `Can't update availability`,
  SEND_EXPIRED_EMAILS: `Send emails when expired`,
  MIN_DISTANCE_BETWEEN_SHIFTS: `Minimal distance between shift`,
  FALLBACK_ID: `Fallback`,
  CONTRACTTYPE: `Contract`,
  PERMITTYPE: `Permit`,
  EMPLOYEETYPE: `Employee`,
  SUBMIT_AVAILABILITIES_ADVANCE: `Availabilities minimum notice`,
  AVAILABILITIES_ADVANCE_DAYS: `Availabilities notice in advance (days)`,
  WORKABLE_HOURS: `Restrict workable hours`,
  RESTRICT_AVAILABILITY: `Restrict availability`,
  WORKABLE_HOURS_START: `Allowed start (restriction)`,
  WORKABLE_HOURS_END: `Allowed end (restriction)`,
  WEEKS: `weeks`,
  DAYS: `days`,
  HOURS: `hours`,
  MINUTES: `minutes`,
  SCHEDULING_SECTION: `Scheduling`,
  AVAILABILITIES_SECTION: `Availabilities`,
  EXPIRATION_SECTION: `Expiration`,
  CSV_EXPORT_NAME: `hiringData_export_{{date}}`,
  form: {
    CREATE: {
      TITLE: `Creating a hiring data`,
      SUMMARY: `Hiring data allows you to filter users and add rules based on the contract/permit linking them to the company.`
    },
    EDIT: {
      TITLE: `Editing a hiring data`,
      SUMMARY: `Hiring data allows you to filter users and add rules based on the contract/permit linking them to the company.`
    },
    NAME: {
      LABEL: `Name`,
      DESCRIPTION: `This name should help you quickly identify the hiring data`,
      PLACEHOLDER: `Enter a name for the hiring data`
    },
    TYPE: {
      LABEL: `Type`,
      DESCRIPTION: `The type helps to seperate different hiring data between them.`
    },
    IMPORTCODE: {
      LABEL: `Import code`,
      DESCRIPTION: `Enter the import code`,
      PLACEHOLDER: `This will be used in the import tools to assign hiring data to users.`
    },
    HASVALIDPERIOD: {
      LABEL: `Has a validity period`,
      DESCRIPTION: `When activating this setting, it will be possible to set a start date and end date when adding a hiring data to a user.`
    },
    NBHOURSMAX: {
      LABEL: `Maximal working hours`,
      DESCRIPTION: `If the user is schedule for more then this amount of hours, they will be flagged.`,
      PLACEHOLDER: `Enter the amount in hours`
    },
    DISPONIBILITIESAPPROVEDBYDEFAULT: {
      LABEL: `Approve availabilities by default`,
      DESCRIPTION: `A user that possesses a hiring data with this setting activated, will see their availabilty request by approved by default.`
    },
    CANNOTUPDATEAVAILABILITIES: {
      LABEL: `Can't update their availabilities`,
      DESCRIPTION: `A user will not be able to update their availabilty request once they have been created.`
    },
    SENDEXPIREDEMAILS: {
      LABEL: `Send a hiring data expiration email`,
      DESCRIPTION: `Each night, you will receive by email a list of the hiring data that are expired or will expire soon. The email to send it to can be defined in settings.`
    },
    MINIMUMDISTANCEBETWEENSHIFTS: {
      LABEL: `Minimum distance between shifts`,
      DESCRIPTION: ``,
      PLACEHOLDER: `Enter the minimum distance in minutes`
    },
    FALLBACKID: {
      LABEL: `Hiring data to use once current data expires`,
      DESCRIPTION: `The selected hiring data will be used when this hiring data is not yet valid or is expired.`
    },
    ACTIVATEWORKABLEHOURS: {
      LABEL: `Limit shift start / end`,
      DESCRIPTION: `This allows to prevent users from working out of there contracted or legally allowed hours.`
    },
    WORKABLEHOURSTART: {
      LABEL: `Earliest possible shift start`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Select the earliest time the user can work`
    },
    WORKABLEHOUREND: {
      LABEL: `Latest possible shift end`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Select the latest time the user can work`
    },
    MUSTSUBMITAVAILABILITIESINADVANCE: {
      LABEL: `Must give a minimum notice to submit their availabilities requests`,
      DESCRIPTION: `This will notify the employees that they must submit their availability requests with a certain amount of days in advance.`
    },
    SUBMITAVAILABILITIESINADVANCEDAYS: {
      LABEL: `Minimum notice in days required to submit an availability request:`,
      DESCRIPTION: `Will be sayed in the warning.`,
      PLACEHOLDER: `Enter the amount of days`
    },
    SUBMITAVAILABILITIESINADVANCETIME: {
      LABEL: `Time of day`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Time to use for the cutoff in the users's timezone.`
    },
    RESTRICTAVAILABILITY: {
      LABEL: `Restrict availabilities`,
      DESCRIPTION: `Will force an employee with this contract to choose from pre-determined blocks of availability.`
    },
    RESTRICTAVAILABILITYTOSCHEDULETYPES: {
      LABEL: `Available blocks`,
      PLACEHOLDER: `Select at least one schedule type`,
      DESCRIPTION: `The schedule types that the user will be allowed to chose from.`
    },
    ENABLEAVAILABILITYSUBMISSIONCUTOFF: {
      LABEL: `Enable cutoff date for availabilities`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Set a date and time for an upcoming week that will prevent employees from submitting their availabilities after the cutoff. We recommend explaning how this works in the custom description field for availabilities.`
    },
    AVAILABILITYSUBMISSIONCUTOFFDAYOFWEEK: {
      LABEL: `Day of week`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Day to use for the cutoff`
    },
    AVAILABILITYSUBMISSIONCUTOFFTIME: {
      LABEL: `Time of day`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Time to use for the cutoff in the users's timezone.`
    },
    AVAILABILITYSUBMISSIONCUTTOFFNUMBEROFWEEKSAHEAD: {
      LABEL: `Number of weeks ahead`,
      PLACEHOLDER: `Enter a number`,
      DESCRIPTION: `Enter 1 for the next week and higher numbers for other weeks, entering zero (0) will do nothing.`
    },
    NAME_REQUIRED: `Name is mandatory.`,
    TYPE_REQUIRED: `Type is mandatory.`
  }
}
